// Phiên bản hiển thị ở Footer — dạng 1.0.XXX (XXX đệm 3 chữ số), tăng thêm 1
// ở mỗi lần deploy hosting mới, không gắn với version trong package.json (đó
// là version của bộ khung Material Dashboard, không phải của app thu mua bơ
// này).
export const PHIEN_BAN = "1.0.015";
